module.exports = __webpack_public_path__ + "img/Pause.72c3831f.png";